/** Client-side mirrors of server image upload caps (bytes). */
export const IMAGE_UPLOAD_MAX_BYTES = 5 * 1024 * 1024; // 5MB
export const IMAGE_UPLOAD_MAX_MB = 5;

export function imageUploadTooLargeMessage(maxMb: number = IMAGE_UPLOAD_MAX_MB): string {
  return `File too large. Maximum size is ${maxMb}MB`;
}
